import { cva } from 'cva';
export const dialogOverlayClassNames = [
    '@fixed',
    '@inset-0',
    '@z-[1001]',
    '@bg-[rgba(0,0,0,0.36)]',
    'data-[state=open]:@animate-in',
    'data-[state=closed]:@animate-out',
    'data-[state=closed]:@fade-out-0',
    'data-[state=open]:@fade-in-0'
];
export const dialogContentClassNames = [
    '@fixed',
    '@z-[1001]',
    '@left-[50%]',
    '@top-[50%]',
    '@translate-x-[-50%]',
    '@translate-y-[-50%]',
    '@w-full',
    '@max-w-[420px]',
    '@px-6',
    '@py-5',
    '@rounded-lg',
    '@border',
    '@border-grey-2_5',
    '@bg-grey-1-b',
    '@shadow-down8',
    '@duration-200',
    'data-[state=open]:@animate-in',
    'data-[state=closed]:@animate-out',
    'data-[state=closed]:@fade-out-0',
    'data-[state=open]:@fade-in-0',
    'data-[state=closed]:@zoom-out-95',
    'data-[state=open]:@zoom-in-95',
    'data-[state=closed]:@slide-out-to-left-1/2',
    'data-[state=closed]:@slide-out-to-top-[48%]',
    'data-[state=open]:@slide-in-from-left-1/2',
    'data-[state=open]:@slide-in-from-top-[48%]',
];
export const dialogHeaderClassNames = [
    '@flex',
    '@flex-col',
];
export const dialogFooterClassNames = [
    '@flex',
    '@flex-col',
    '@mt-5',
    '@space-y-2',
    'sm:!@flex-row-reverse',
    'sm:!@justify-start',
    'sm:!@space-x-reverse',
    'sm:!@space-x-2',
    'sm:!@space-y-0',
];
export const dialogTitleVariant = cva({
    base: [
        '@flex',
        '@items-center',
        '@text-h1',
        '@text-grey-6',
        '@font-medium',
        '@peer/title',
        '@m-0',
        '[&>[data-icon]]:@w-6',
        '[&>[data-icon]]:@h-6',
        '[&>[data-icon]]:@mr-3',
    ],
    variants: {
        state: {
            info: ['[&>[data-icon]]:@text-brand1-1'],
            success: ['[&>[data-icon]]:@text-success1-1'],
            error: ['[&>[data-icon]]:@text-red1-1'],
            warning: ['[&>[data-icon]]:@text-warning1-1'],
            loading: ['[&>[data-icon]]:@text-brand1-1', '[&>[data-icon]]:@animate-spin'],
        },
    },
});
export const dialogDescriptionClassNames = [
    'peer-[[data-icon]]/title:@ml-9',
    '@mb-0',
    '@mt-1.5',
    '@text-b2',
    '@text-grey-5',
];
export var DialogCloseIntent;
(function (DialogCloseIntent) {
    DialogCloseIntent["Action"] = "action";
    DialogCloseIntent["Cancel"] = "cancel";
    DialogCloseIntent["Close"] = "close";
})(DialogCloseIntent || (DialogCloseIntent = {}));
